// © Microsoft Corporation. All rights reserved.

import { ActionMap } from "@msnews/experiences-redux";
import { SocialDataState } from "@msnews/social-data-connector";

export type SetComponent = (moduleName?: string, id?: string, market?: string, specificCommentId?: string, commentDisplayType?: string) => void;

export type SetSocialData = (socialData: SocialDataState) => void;

export const SocialActions = {
    setComponent: new ActionMap<SetComponent>("SetComponent"),
    setSocialData: new ActionMap<SetSocialData>("SetSocialData")
};